import store from '@/store';

export default async (to, from, next) => {
  if (store.getters['user/needNymOnboarding'] && !to.params.skipOnboarding) {
    next({ name: 'onboarding' });
  } else {
    next();
  }
};
